export default {
  computed: {
    draftForDiscussion: () => () => ({}),
  },
  methods: {
    showDraft: () => false,
    addReplyToReview: () => {},
    addToReview: () => {},
  },
};
